// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"582":"a38ea156","793":"3b972541"}[chunkId] + ".css";
};